export class DipendenteDTO {
    nome: string;
    cognome: string;
    cf: string;
    matricola: string;
    cmu: string;
    descrizioneCmu: string;
    codiceEnte: string;
}